'use client';

import { useQuery } from '@tanstack/react-query';
import { curatorQueries } from '../../query-factory';

/** 29CM 배송지 변경 화면 — 큐레이터 등록 배송지 목록 조회. */
export const useSeedingDeliveryAddresses = (enabled = true) =>
  useQuery({
    ...curatorQueries.campaigns.seedingDeliveryAddresses(),
    enabled,
    staleTime: 60_000,
  });
